import { farasod } from "./api"

const endpoint = "/achievement"

export const getAchievements = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const createAchievement = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateAchievement = async (subscriptionLevelId, data) => {
  const response = await farasod.patch(`${endpoint}/${subscriptionLevelId}`, data)

  return response.data
}

export const deleteAchievement = async (subscriptionLevelId) => {
  const response = await farasod.delete(`${endpoint}/${subscriptionLevelId}`)

  return response.data
}

export const getLoyaltyAdminSummary = async () => {
  const response = await farasod.get(`${endpoint}/loyalty/admin-summary`)
  return response.data
}

export const getCustomerLoyaltyOverview = async accountId => {
  const response = await farasod.get(`${endpoint}/loyalty/overview?accountId=${accountId}`)
  return response.data
}
